import React from 'react'
import { AnchorsOfFormsWrappers } from '@constants/forms'
import { EstateAgentsForm } from '@shared/components/forms/estate-agents'
import { Section } from '@shared/components/section'

import { partnerFormSummary } from './data'

import styles from './style.module.scss'

export const View = () => (
	<Section id={AnchorsOfFormsWrappers.partner} fullWidth className={styles.fluidWrapper}>
		<Section className={styles.wrapper}>
			<div className={styles.summary}>
				<h2 className={styles.title}>Оставьте заявку на ипотеку</h2>
				<div className={styles.summaryContent}>
					{partnerFormSummary.map(({ Icon, content }, i) => (
						<div key={i} className={styles.summaryItem}>
							<Icon className={styles.summaryItemIcon} />
							{content}
						</div>
					))}
				</div>
			</div>
			<div className={styles.formWrapper}>
				<EstateAgentsForm
					placeholders={['Ваше имя', 'Номер телефона', 'Электронная почта']}
					btnText='Отправить'
				/>
			</div>
		</Section>
	</Section>
)
